import React from 'react';

import styles from './tag.scss';

export interface TagProps {
  children: React.ReactNode;
  className?: string;
}

export const Tag = ({ children, className }: TagProps) => (
  <div className={`${styles.tag} ${className}`}>
    {children}
  </div>
);
